import OverrideDaysTable from './OverrideDaysTable';

export default OverrideDaysTable;
